import * as React from "react";
import { connect } from "react-redux";
import { selectCategoryPosition, selectUiDefinitionCategories, } from "../../balancingSelectors/selectBalancingUiDefinitions";
import { IdMenuBalancing } from "../../constants/IdMenuBalancing";
import { selectIsRankingAvailable, selectIsTournamentLevelMatched, selectPlayerTournamentBuildingActiveTabId, selectRunningTournamentInfo, selectTournamentEndTime, } from "../../selectors/selectTournamentInfo";
import { EventType } from "../balancing/types/BalancingCore";
import { actionPlayerLeagueDeselectLeague } from "../info/league/actionPlayerLeagueInfo";
import { MenuWrapper } from "../menus/MenuWrapper";
import { actionModalClose } from "../modals/actionModal";
import { IdModal } from "../modals/IdModal";
import { TimeRemaining } from "../time/TimeRemaining";
import { IdTournamentCategory } from "./IdTournamentCategory";
export var _MenuTournament = function (_a) {
    var onClose = _a.onClose, endTime = _a.endTime, selectedTab = _a.selectedTab, isRankingTabAvailable = _a.isRankingTabAvailable, isRewardsTabAvailable = _a.isRewardsTabAvailable;
    var timeRemaining = endTime > 0 ? React.createElement(TimeRemaining, { remainingTime: endTime }) : undefined;
    var passGetLockedTabs = function (tabs) {
        return getLockedTabs(tabs, isRankingTabAvailable, isRewardsTabAvailable);
    };
    return (React.createElement(MenuWrapper, { onClose: onClose, className: "tournament-dialog", type: IdMenuBalancing.Tournament, filterTabs: getFilteredTabs, lockedTabs: passGetLockedTabs, footerRenderer: timeRemaining, activeTabIndex: selectedTab, modalId: IdModal.TournamentTent }));
};
var getFilteredTabs = function (tabs) {
    // the following are not allowed because they are sub-tabs
    var notAllowedTabs = [
        IdTournamentCategory.collectLeagueRewards,
        IdTournamentCategory.coopLeagueRewards,
        IdTournamentCategory.playerLeagueRewards,
    ];
    return tabs.filter(function (tab) { return notAllowedTabs.indexOf(tab.id) < 0; });
};
var getLockedTabs = function (tabs, isRankingTabAvailable, isRewardsTabAvailable) {
    var returnedTabs = [];
    if (!isRankingTabAvailable) {
        returnedTabs.push(IdTournamentCategory.LeagueRanking);
    }
    if (!isRewardsTabAvailable) {
        returnedTabs.push(IdTournamentCategory.LeagueOverview);
    }
    return returnedTabs;
};
var mapDispatch = function (dispatch) { return ({
    onClose: function () {
        dispatch(actionModalClose(IdModal.TournamentTent));
        dispatch(actionPlayerLeagueDeselectLeague());
    },
}); };
var mapState = function (state) {
    var menuId = IdMenuBalancing.Tournament;
    var currentTournamentInfo = selectRunningTournamentInfo(state);
    var filteredTabs = getFilteredTabs(selectUiDefinitionCategories(menuId));
    var selectedTabId = selectPlayerTournamentBuildingActiveTabId(state);
    return {
        endTime: selectTournamentEndTime(state, currentTournamentInfo),
        isRankingTabAvailable: selectIsRankingAvailable(state),
        isRewardsTabAvailable: selectIsTournamentLevelMatched(state, EventType.PlayerLeague),
        selectedTab: selectCategoryPosition(menuId, selectedTabId, filteredTabs),
    };
};
export var MenuTournament = connect(mapState, mapDispatch)(_MenuTournament);



//////////////////
// WEBPACK FOOTER
// ./src/features/tournament-building/MenuTournament.tsx
// module id = 2955
// module chunks = 3